import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PRTestResults } from './types';

type VisualTestingState = {
  results: Record<string, PRTestResults>;
  loading: boolean;
  error: string | null;
};

const initialState: VisualTestingState = {
  results: {},
  loading: true,
  error: null,
};

const visualTestingSlice = createSlice({
  name: 'visualTesting',
  initialState,
  reducers: {
    setResults: (
      state,
      action: PayloadAction<{ prId: string; results: PRTestResults }>,
    ) => {
      state.results[action.payload.prId] = action.payload.results;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
  },
});

export const { setResults, setLoading, setError } = visualTestingSlice.actions;
const reducer = { visualTesting: visualTestingSlice.reducer };

export default reducer;
